import { useAuth } from "@/auth/auth.ts";
import useSWR from "swr";
import type { APIError, Limrun } from "@limrun/api";

type UseAssetsOptions = {
	enabled?: boolean;
	organizationTid?: string;
	includeAppStore?: boolean;
	limit?: number;
	namePrefixFilter?: string;
};

export function getAssetsKey({
	enabled = true,
	organizationTid,
	includeAppStore = false,
	limit,
	namePrefixFilter,
}: UseAssetsOptions = {}): string | null {
	if (!enabled || !organizationTid) {
		return null;
	}

	const params = new URLSearchParams({
		includeAppStore: String(includeAppStore),
	});
	if (limit !== undefined) {
		params.set("limit", String(limit));
	}
	if (namePrefixFilter) {
		params.set("namePrefixFilter", namePrefixFilter);
	}
	return `assets-${organizationTid}-${params.toString()}`;
}

export function useAssets({
	enabled = true,
	organizationTid,
	includeAppStore = false,
	limit,
	namePrefixFilter,
}: UseAssetsOptions = {}): {
	data: Limrun.AssetListResponse | "loading";
	error?: APIError;
} {
	const auth = useAuth();
	const { data, error } = useSWR(
		getAssetsKey({
			enabled,
			organizationTid,
			includeAppStore,
			limit,
			namePrefixFilter,
		}),
		async () => {
			return auth.regionClient.assets.list({
				includeAppStore,
				limit,
				namePrefixFilter,
			} as Limrun.AssetListParams);
		},
	);
	return {
		data: data ?? "loading",
		error,
	};
}
